<div class="ai-loading-overlay">
	<div class="ai-loading-content">
		<div class="loading-animation">
			<mat-icon svgIcon="smart-stars" class="smart-stars-icon animated"></mat-icon>
			<div class="magic-particles">
				<span class="particle"></span>
				<span class="particle"></span>
				<span class="particle"></span>
				<span class="particle"></span>
			</div>
		</div>
		<div class="message-container">
			<h3 class="loading-title">{{ 'analyzing_images' | translate }}</h3>
			<p class="loading-message">{{ currentMessage() | translate }}</p>
			<p class="ai-note">{{ 'ai_generated_content_warning' | translate }}</p>
		</div>
	</div>
</div>
